import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-light" }, "jamz", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-black" }, "care", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Sign Out", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_v_toolbar, {
      flat: "",
      app: "",
      color: "light-grey"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawer = !_ctx.drawer))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { class: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-dots-vertical")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_icon, {
          large: "",
          class: "mr-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: require('@/assets/logo_transparent.png'),
              height: "500px",
              width: "40px"
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_toolbar_title, { class: "text-uppercase grey--text mr-0 ml-0" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_tooltip, {
          text: "Your Current Location",
          location: "top"
        }, {
          activator: _withCtx(({ props }) => [
            (!_ctx.store.location)
              ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                  key: 0,
                  variant: "elevated",
                  color: "jamzcare",
                  label: ""
                }, props), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      icon: "mdi-map-marker"
                    }),
                    _createTextVNode(" WARD 12 ")
                  ]),
                  _: 2
                }, 1040))
              : _createCommentVNode("", true),
            (_ctx.store.location)
              ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                  key: 1,
                  variant: "elevated",
                  color: "jamzcare",
                  label: ""
                }, props), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      icon: "mdi-map-marker"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.store.location), 1)
                  ]),
                  _: 2
                }, 1040))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          flat: "",
          color: "grey",
          to: "/login",
          class: "ma-2",
          label: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { right: "" }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-exit-to-app")
              ]),
              _: 1
            }),
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_navigation_drawer, {
      "expand-on-hover": "",
      rail: "",
      permanent: "",
      color: "jamzcare"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (!this.store.username)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  "prepend-avatar": require('@/assets/phoebe.png'),
                  title: "Phoebe",
                  subtitle: "phoebe@aislaapps.com"
                }, null, 8, ["prepend-avatar"]))
              : _createCommentVNode("", true),
            (this.store.username)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 1,
                  "prepend-avatar": _ctx.getImage(),
                  title: this.store.userTitle,
                  subtitle: this.store.email
                }, null, 8, ["prepend-avatar", "title", "subtitle"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, i) => {
          return (_openBlock(), _createBlock(_component_v_list, {
            density: "compact",
            nav: "",
            key: i
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                "prepend-icon": link.icon,
                title: link.title,
                router: "",
                to: link.route
              }, null, 8, ["prepend-icon", "title", "to"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}